import apiService from './apiService';

const tempsService = {
  async listProducts() {
    return apiService.get('/temps/products');
  },

  async listProdUsers() {
    return apiService.get('/temps/prod-users');
  },

  async createTemplate(body) {
    return apiService.post('/temps/templates', body);
  },

  async updateTemplate(id, body) {
    return apiService.patch(`/temps/templates/${id}`, body);
  },

  async deleteTemplate(id) {
    return apiService.delete(`/temps/templates/${id}`);
  },

  async listCommandes({ q = '', scope = 'prod', marques = [] } = {}) {
    return apiService.get('/temps/commandes', {
      q,
      scope,
      marques: Array.isArray(marques) && marques.length ? marques.join(',') : '',
    });
  },

  async setCommandeFlag(id, concernsProd) {
    return apiService.patch(`/temps/commandes/${id}/flag`, { concernsProd });
  },

  async syncCommandes() {
    return apiService.post('/temps/commandes/sync', {}, {}, { timeout: 600000 });
  },

  async weekBoard(week) {
    return apiService.get('/temps/week', { week });
  },

  async weekTeam(week) {
    return apiService.get('/temps/week/team', { week });
  },

  async listTasks(scope, week) {
    return apiService.get('/temps/tasks', { scope, week });
  },

  async createTask(body) {
    return apiService.post('/temps/tasks', body);
  },

  async updateTask(id, body) {
    return apiService.patch(`/temps/tasks/${id}`, body);
  },

  async deleteTask(id) {
    return apiService.delete(`/temps/tasks/${id}`);
  },

  async claimTask(id, week) {
    return apiService.post(`/temps/tasks/${id}/claim`, week ? { week } : {});
  },

  async reopenTask(id) {
    return apiService.post(`/temps/tasks/${id}/reopen`, {});
  },

  async validateTask(id, actualMinutes) {
    return apiService.post(`/temps/tasks/${id}/validate`, { actualMinutes });
  },

  async archiveTask(id) {
    return apiService.post(`/temps/tasks/${id}/archive`, {});
  },

  async setTaskStatus(id, status) {
    return apiService.post(`/temps/tasks/${id}/status`, { status });
  },

  async archiveOrder(id) {
    return apiService.post(`/temps/commandes/${id}/archive-validated`, {});
  },
};

export default tempsService;
